import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service'
import { Router, ActivatedRoute } from '@angular/router'
import { ExcelService } from '../../exceldownloader';
import * as XLSX from 'xlsx';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { chemistmasterdata } from '../../model';
import * as $ from 'jquery';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-newretalleraddition',
    template: require('./newretalleraddition.component.html'),
    styles: [require('./newretalleraddition.component.css')]
})
export class NewRetallerAddition implements OnInit {
    chemistList: any = [];
    headQuarterList: any = [];
    stateList: any = [];
    busy: Subscription;
    empData: any = [];
    private columnDefs;
    private rowHeight;
    api: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token:any;
    form_data = new FormData();

    chemistmasterdataModel: chemistmasterdata = new chemistmasterdata();

    static parameters = [ApiService, Router, ActivatedRoute, NgbModalConfig, NgbModal, ExcelService];
    constructor(private apiService: ApiService, private router: Router, private activatedRoute: ActivatedRoute, config: NgbModalConfig, private modalService: NgbModal, private excelService: ExcelService) {
        config.backdrop = 'static';
        config.keyboard = false;
        let parent = this;
        this.columnDefs = [
            { headerName: 'Employee Code', field: "EmployeeCode", width: 200, filter: 'agTextColumnFilter' },
            { headerName: 'Employee Name', field: "EmployeeName", width: 200, filter: 'agTextColumnFilter' },
            { headerName: 'Chemist Name', field: "ChemistName", width: 250, filter: 'agTextColumnFilter' },
            { headerName: 'Headquarter', field: "HQName", width: 200, filter: 'agTextColumnFilter' },
            { headerName: 'State', field: "StateName", width: 200, filter: 'agTextColumnFilter' },
            // { headerName: 'Approval Status', field: "status", width: 150, filter: 'agTextColumnFilter' },
            {
                headerName: 'Status', field: 'status', width: 100, cellRenderer: function (params) {
                    if (params.data.status == 0) {
                        var showdata = 'Pending';
                        return showdata;
                    }
                    if (params.data.status == 1) {
                        var showdata = 'Approve';
                        return showdata;
                    }
                    if (params.data.status == 1) {
                        var showdata = 'Rejected';
                        return showdata;
                    }
                }
            },
            { headerName: 'Approve By', field: "ApprovedBy", width: 150, filter: 'agTextColumnFilter' },
            { headerName: 'Approval Date', field: "ApprovedDate", filter: 'agTextColumnFilter' },

        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.chemistmasterdataModel.Client_Code = '0';
        this.chemistmasterdataModel.Category = '0';
        this.chemistmasterdataModel.HQ = '0';
        this.chemistmasterdataModel.StateID = 0;
        this.chemistList = [];
        $('#filter-option').trigger('click');
        this.getEmployee();
        this.getState();
        this.getHeadQuarterList();
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
        })
    }

    getState() {
        this.apiService.getState().subscribe((res: any) => {
            this.stateList = res.data;
        })
    }

    getHeadQuarterList() {
        this.apiService.getHeadQuarterList().subscribe((res: any) => {
            this.headQuarterList = res.data;
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'New Retailer Addition' });
    }

    open(content) {
        this.modalService.open(content);
    }

    getChemistList() {
        //this.api.showLoadingOverlay();
        // var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        // let id = tokenData.id
        //console.log(this.chemistmasterdataModel);
        this.chemistmasterdataModel.LoginId=this.token.id;
         // console.log(this.chemistmasterdataModel);
       this.busy = this.apiService.newretailerlist(this.chemistmasterdataModel).subscribe((res: any) => {
          //  console.log('response ', res);
            //this.api.showNoRowsOverlay();
            this.chemistList = res.employee;
        });
    }

    editChemist(event) {
        console.log("chemist")
        this.router.navigate(['home/chemistadd'], { queryParams: event });
    }

    InActive(event) {
        // var tokenData = JSON.parse(sessionStorage.getItem("currentUser"));
        // let id = tokenData.id

        let id = { _ID: event._ID };
        this.apiService.inactiveChemist(id).subscribe((res: any) => {
            if (Number(event.status)) {
                alert("Chemist Active");
            } else {
                alert("Chemist In-Active");
            }
            // alert(res.msg);
        })
    }

    // inputExcelOnClick(event){
    //   if(event.target.files!=null&&event.target.files.length==0)
    //         {
    //         throw new Error('Please select the file');
    //         }
    //         else if(event.target.files!=null&&event.target.files.length>1){
    //           throw new Error('Multiple files are not allowed')
    //         }
    //         this.form_data= event.target.files[0];
    //         debugger
    //         this.apiService.UploadEmployee(this.form_data).subscribe(
    //           (res:any)=>{
    //             alert(res.msg)
    //             })
    // }

    downloadFile(data: any) {
        this.excelService.exportAsExcelFile(data, 'ChemistList');
    }

    inputExcelOnClick(ev) {
        let workBook = null;
        let jsonData = null;
        const reader = new FileReader();
        const file = ev.target.files[0];
        reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial, name) => {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
                return initial;
            }, {});
            const dataString = {};
            dataString["data"] = jsonData[Object.keys(jsonData)[0]];
            // console.log('datastring ', dataString);
            this.apiService.UploadEmployee(dataString).
                subscribe((res: any) => {
                    $('#file').val(null);
                    this.getChemistList()
                    if (res.data.length > 0) {
                        this.downloadFile(res.data);
                        alert("Downloaded file can not be uploaded as HeadQuarter not match! Please enter HeadQuarter first")
                    } else {
                        alert("File has been succussfully uploaded");
                    }
                }, error => {
                    $('#file').val(null);
                })
            // document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
        }
        reader.readAsBinaryString(file);
    }
}
